import MainButton from "~/components/common/mainButton";
import { useLanguage } from "~/contexts/providers/language";
import englishTranslations from "~/localization/en";
import frenchTranslations from "~/localization/fr";

const ApplicationSuccessful = () => {
  const { language } = useLanguage();

  const successfulTexts =
    language === "En"
      ? englishTranslations.applyPage.successful
      : frenchTranslations.applyPage.successful;
  return (
    <>
      <p>{successfulTexts.title}</p>
      <MainButton
        uiOnly={true}
        style={{
          color: "var(--color-green)",
          borderColor: "var(--color-green)",
        }}
      >
        {successfulTexts.header}
      </MainButton>

      <p>{successfulTexts.response}</p>

      <div>
        <p>{successfulTexts.validatedTitle}</p>
        {[
          successfulTexts.validatedMessage1,
          successfulTexts.validatedMessage2,
          successfulTexts.validatedMessage3,
        ].map((validationStep, i) => (
          <p key={`success-validation-step-${i}`}>→ {validationStep}</p>
        ))}
      </div>
    </>
  );
};

export default ApplicationSuccessful;
